import type {
  ComponentData,
  ImageComponentData,
  UpdateEntityFileSelectFunc,
  UpdateEntityFileUploadFunc,
  VideoComponentData,
} from './../ricos-content';
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const GALLERY_TYPE = 'wix-draft-plugin-gallery';

export type FileSelectionHandlerFn = (
  index: number | undefined,
  multiple: boolean,
  updateEntity: UpdateEntityFileSelectFunc<ImageComponentData[]>,
  removeEntity?: any,
  componentData?: ComponentData
) => void;

export type FileUploadHandlerFn = (
  file: File,
  updateEntity: UpdateEntityFileUploadFunc<ImageComponentData | VideoComponentData>
) => void;

export interface GalleryPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  handleFileSelection?: FileSelectionHandlerFn; // either handleFileSelection or handleFileUpload should be required
  handleFileUpload?: FileUploadHandlerFn;
  /**
   * Gallery doesn't work well when multiple galleries with same nodeId are rendered on the same page.
   * Use this prop to ensure each gallery has a unique id.
   * Value should contain only letters, numbers, hyphens or underscores.
   */
  scopingId?: string;
}
export interface GalleryPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  /**
   * @default false
   * When set to true, the gallery items will not expand despite the settings in node data.
   */
  disableExpand?: boolean;
  /**
   * Gallery doesn't work well when multiple galleries with same nodeId are rendered on the same page.
   * Use this prop to ensure each gallery has a unique id.
   * Value should contain only letters, numbers, hyphens or underscores.
   */
  scopingId?: string;
}
